import React from 'react';

import Social from '../Social/Social';
import LogoFabriek from '../Icons/LogoFabriek';

import './Footer.css';

const Footer = (props) => {

		return (
		  <div className="footer">
		  	<a href="https://www.argumentenfabriek.nl"
			  	target="_blank"
			  	rel="noopener noreferrer">
			  	<LogoFabriek />
		  	</a>
		  	<Social
					url=""
					title=""
					text=""
					message=""
					test
		  	 />
		  </div>
		)
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js